import _ from 'lodash';
import { Observable, from } from 'rxjs';
import { clearToken } from './utility';

const BASE_API_URL = process.env.REACT_APP_API_URL;

const customHeader = (): Headers => {
    const header = new Headers();

    const token = localStorage.getItem('id_token') || '';
    if (token) {
        header.append('Authorization', `Bearer ${token}`);
    }

    return header;
};

class ResponseException {
    constructor(error: { [key: string]: any }) {
        _.assign(this, error);
    }
}

const base = (method: string, url: string, data: any = {}): Observable<any> => {
    const headers: Headers = customHeader();
    headers.append('Content-Type', 'application/json; charset=UTF-8');
    headers.append('Accept', '*/*');

    const options: any = {
        method: _.includes(['DOWNLOAD', 'UPLOAD'], method) ? 'POST' : method,
        headers: headers,
    };

    if (method === 'UPLOAD') {
        options.body = data;
        options.headers = customHeader();
    }

    if (['POST', 'PUT', 'PATCH', 'DOWNLOAD'].includes(method)) {
        options.body = JSON.stringify(data);
    }

    const fullUrl = _.join([_.trim(BASE_API_URL, '/'), _.trim(url, '/')], '/');

    return from(
        fetch(fullUrl, options).then(async (response) => {
            const status = response.status;

            const res = _.pick(response, [
                'status',
                'headers',
                'bodyUsed',
                'ok',
                'redirected',
                'statusText',
                'type',
                'url',
            ]);

            if (status < 200 || status > 299) {
                let error = '';
                const _response = response.clone();

                try {
                    error = await response.json();
                } catch (e) {
                    error = await _response.text();
                }

                if (status === 401) {
                    clearToken();
                    return window.location.reload(true);
                }

                throw new ResponseException({
                    ...res,
                    error
                });
            }

            if (method === 'DOWNLOAD') {
                return await response.arrayBuffer();
            }

            return {
                ...res,
                data: await response.json(),
                status,
            };
        })
    );
};
const Http = {
    get: base.bind(null, 'GET'),
    post: base.bind(null, 'POST'),
    put: base.bind(null, 'PUT'),
    delete: base.bind(null, 'DELETE'),
    patch: base.bind(null, 'PATCH'),
    upload: base.bind(null, 'UPLOAD'),
    download: base.bind(null, 'DOWNLOAD'),
};

export default Http;
